import { Contribution, Operation, Partner } from 'types';

export const getPartnersFromOldContribution = (
  operation: Operation | undefined
): Partner[] => {
  if (!operation?.contributions?.length) return [];

  return (operation.contributions as Contribution[])
    .map((contribution) => contribution.partner)
    .filter((partner): partner is Partner => !!partner);
};
